<template lang="pug">
  Modal(v-bind="$attrs")
    div.flex.items-start.pr-8
      span(class="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-default")
        Icon(icon="users", class="text-xl")
      div.ml-5
        h1.text-xl.font-semibold.text-heading For co-branding
        p.mt-1.text-paragraph Invite partners to add their branding and share this content

    ShareLinkField.mt-8(:url="inviteUrl", label="Co-branding invitation link", accent="secondary")

    div.mt-6.space-y-2
      ShareAction(:href="`${$apiUrl}go/collections/${hashid}/invite/qr?download`", accent="secondary", icon="qrcode", trailing-icon="download", title="Download QR code", description="Let partners scan to add their branding and share")
</template>

<script>
import ShareAction from "@/components/ShareAction"
import ShareLinkField from "@/components/ShareLinkField"

export default {
  components: {
    ShareAction,
    ShareLinkField
  },
  props: {
    hashid: {
      type: String,
      required: true
    },
    inviteUrl: {
      type: String,
      required: true
    }
  }
}
</script>
